import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Link.css';

interface ILinkProps {
  url: string;
  text: string;
  size?: 'XS' | 'M';
  onClick?(): void;
  id?: string;
}

export function Link({ id, url, text, size = 'XS', onClick }: ILinkProps) {
  return (
    <a
      id={id}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(styles['link'], { [styles['link--m']]: size === 'M' })}
      onClick={onClick}
    >
      {text}
    </a>
  );
}
